import type { GmfDeveloperPipelineFormValues } from './types/gmfDeveloperPipeline.types';

export const GMF_DEVELOPER_PIPELINE_TEMPLATE_CODE = 'gmf-dev-pipe';

export const yesNoOptions = ['Yes', 'No'] as const;

export const projectByRightOptions = ['Yes', 'No', 'Not Yet Determined'];

export const constructionTypeOptions = ['New Construction', 'Rehab', 'Historic Renovation', 'Adaptive Reuse', 'In-Place Renovation'];

export const acquisitionTypeOptions = [
  'Purchase',
  'Donation',
  'Lease',
  'Off-Market',
  'On-Market',
  'Joint venture with land owner',
  'Other',
];

export const siteControlStatusOptions = ['LOI Obtained', 'Under Contract', 'Owned', 'On-Market', 'RFP Submitted', 'Other'];

export const applicantIdentityOptions = [
  'Minority-Owned Developer',
  'Woman-Owned Developer',
  'Neighborhood-Based Organization',
  'Community-Based Organization',
  'Nonprofit Developer',
  'For-Profit Developer',
];

export const professionalTrainingOptions = ['ACRE cohort year', 'WHEDA programs', 'CDFI training', 'Other relevant programs'];

export const organizationTypeOptions = ['For-Profit', 'Nonprofit', 'Community-Based Organization', 'Other'];

export const initialGmfDeveloperPipelineValues: GmfDeveloperPipelineFormValues = {
  projectDetails: {
    streetAddress: '',
    city: 'Milwaukee',
    state: 'Wisconsin',
    dealType: 'Homeownership',
    zipCode: '',
    proposedUnits: '',
    projectByRight: '',
    constructionType: '',
    acquisitionType: '',
    siteControlStatus: '',
    acquisitionCostEstimate: '',
    developmentCostEstimate: '',
    preDevelopmentCostEstimate: '',
    communityNeed: '',
    targetPopulation: '',
    preliminaryFinancingStrategy: '',
    preliminaryDevelopmentTimeline: '',
    keyPartners: '',
    selectedFiles: [],
    additionalDocs: [],
  },
  applicantInformation: {
    entityName: '',
    businessEntityState: '',
    website: '',
    formationDate: '',
    businessStreetAddress: '',
    businessCity: '',
    businessState: '',
    businessZipCode: '',
    contactPersonName: '',
    contactPersonEmail: '',
    phone: '',
    dateOfBirth: '',
    residentialAddressDifferent: 'No',
    residentialStreetAddress: '',
    residentialCity: '',
    residentialState: '',
    residentialZipCode: '',
    acreGraduate: '',
    applicantIdentity: [],
    educationBackground: '',
    professionalLicenses: '',
    professionalTrainingHistory: [],
    realEstateEntities: '',
    currentEmployerRole: '',
    organizationType: '',
  },
  experience: {
    companyCompleted: [],
    principalCompleted: [],
  },
};

export const dashboardTooltips = {
  totalDevelopers: 'Demonstrates ecosystem engagement and developer participation.',
  totalProjects: 'Quantifies total pipeline activity.',
  totalUnits: 'Core production metric for fundraising conversations.',
  developmentCost: 'Quantifies total capital demand across the ecosystem.',
  predevelopmentNeed: 'Helps justify creation of predevelopment funding pools.',
  averageProjectSize: 'Helps funders understand the scale of typical projects.',
  costPerUnit: 'Useful for benchmarking and underwriting conversations.',
  map: 'Demonstrates neighborhood-level impact and geographic distribution.',
  zipCode: 'Identifies concentration of activity and underserved areas.',
  neighborhood: 'Demonstrates production potential by neighborhood.',
  siteControl: 'Measures project readiness and pipeline maturity.',
  constructionType: 'Explains composition of the pipeline.',
  pipelineStage: 'Summarizes how far submitted projects have advanced through the development pipeline.',
  acreGraduate: 'Measures effectiveness of existing developer support programs.',
  acquisitionCost: 'Helps support acquisition fund fundraising.',
  minorityOwned: 'Supports equity-focused fundraising and impact reporting.',
  neighborhoodBased: 'Demonstrates community-rooted development activity.',
  organizationType: 'Helps characterize ecosystem composition.',
};
